import { Injectable, inject } from '@angular/core';
import { ObjectTypeEnum } from '@shared/model/enum/object-type-enum';
import { BookmarkAggrigatorService } from '../Aggrigators/bookmark-aggrigator.service';
import { Observable } from 'rxjs';
import { ServiceResult } from '@shared/helper/service-result';
import { BookmarkService } from '../bookmark.service';

@Injectable({
  providedIn: 'root'
})
export class BookmarkHandlerService {
  private bookmarkService = inject(BookmarkService);
  private bookmarkAggrigatorService = inject(BookmarkAggrigatorService);


  handleBookmark(bookMark: CreateBookmarkModel): Observable<ServiceResult> {
    if (bookMark.userMarked) {
      return this._unMark(bookMark)
    }
    return this._mark(bookMark);
  }

  private _unMark(bookMark: CreateBookmarkModel): Observable<ServiceResult> {
    return this.bookmarkService.unMark(bookMark.objectId);
  }

  private _mark(bookMark: CreateBookmarkModel): Observable<ServiceResult> {
    return this.bookmarkAggrigatorService.mark(bookMark);
  }

}

export class CreateBookmarkModel {
  objectId = '';
  userMarked = false;
  objectType!: ObjectTypeEnum;
  object?: any;
}